import { API_BASE_URL } from '../../../lib/api';

import { apiFetch } from '@/lib/apiFetch';
import { withTenant } from '../../../lib/tenantHeaders';

const JSON_HEADERS = withTenant({ 'Content-Type': 'application/json' });

export const fetchClients = async ({ query = {} } = {}) => {
  const res = await apiFetch(`${API_BASE_URL}/clients/filter`, {
    method: 'POST',
    headers: JSON_HEADERS,
    body: JSON.stringify({ limit: 1, offset: 1, query }),
  });
  return res.json();
};

export const fetchClient = async (id) => {
  const res = await apiFetch(`${API_BASE_URL}/clients/${id}`, { headers: withTenant() });
  return res.json();
};

export const createClient = async (data) => {
  const res = await apiFetch(`${API_BASE_URL}/clients`, {
    method: 'POST',
    headers: JSON_HEADERS,
    body: JSON.stringify(data),
  });
  return res.json();
};

export const updateClient = async (id, data) => {
  const res = await apiFetch(`${API_BASE_URL}/clients/${id}`, {
    method: 'PUT',
    headers: JSON_HEADERS,
    body: JSON.stringify(data),
  });
  return res.json();
};

export const deleteClient = async (id) => {
  const res = await apiFetch(`${API_BASE_URL}/clients/${id}`, {
    method: 'DELETE',
    headers: withTenant(),
  });
  return res.json();
};
